import React from 'react';
import {View, StyleSheet} from 'react-native';
import {
  Appbar,
  useTheme,
} from 'react-native-paper';

interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
  navigation?: any;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  title = 'Care Badge',
  navigation,
}) => {
  const theme = useTheme();

  const openDrawer = () => {
    if (navigation) {
      navigation.openDrawer();
    }
  };

  return (
    <View style={[styles.container, {backgroundColor: theme.colors.background}]}>
      {/* Navbar with menu */}
      <Appbar.Header style={[styles.navbar, {backgroundColor: theme.colors.surface}]}>
        <Appbar.Action
          icon="menu"
          onPress={openDrawer}
          color={theme.colors.primary}
          size={24}
        />
        <Appbar.Content 
          title={title} 
          titleStyle={[styles.navbarTitle, {color: theme.colors.primary}]}
        />
      </Appbar.Header>

      {/* Main Content */}
      <View style={[styles.content, {backgroundColor: theme.colors.background}]}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  navbar: {
    elevation: 2,
  },
  navbarTitle: {
    fontSize: 18,
    fontWeight: '600',
  },
  content: {
    flex: 1,
  },
});
